'use client';

import * as React from 'react';
/**
 * @ignore - internal component.
 */

export const DialogsContext = /*#__PURE__*/React.createContext(null);